'use strict';

import aceRequest from '../ace-request';

(() => {
  window.atex = window.atex || {};
  window.atex.aceui = window.atex.aceui || {};
  window.atex.aceui.service = window.atex.aceui.service || {};

  /**
   * Create a StructureService object containing functionality to communicate
   * with an ace structure service.
   * 
   * @param {string} serviceUrl An URL to a structure service in an ACE Content REST API
   * @param {object} [serviceSettings]
   * @param {boolean} [serviceSettings.cacheBusting] If true, request an uncached response
   */
  atex.aceui.service.StructureService = function (serviceUrl, { cacheBusting, adaptedAxios }) {
    return {
      /**
       * Get the content structure where the content with "alias" is the root.
       * @param {Object} params
       * @param {string} params.alias Alias of the content that is the root of the structure
       * @param {string} params.token An authentication token
       * @returns {Promise} Resolved with the content structure
       */
      getContentStructure: async ({ alias, token }) => {
        let url = `${serviceUrl}/alias/${alias}`;

        if (cacheBusting) {
          url += `?cacheBusting=${Math.random().toString().substring(2)}`;
        }

        try {
          let response = await aceRequest ({ url, token }, adaptedAxios);
          return response.body;
        } catch (error) {
          let e = atex.aceui.HTTPUtils.createError(error.rootCause.request || error.rootCause, 'atex.aceui.service.StructureService', {
            401: `Could not authenticate user while getting content structure for "${alias}" from the server`,
            403: `Permission denied when getting content structure for "${alias}" from the server`,
            404: `Content structure "${alias}" was not found on the server (404)`,
            'default': `There was an error while getting content structure for "${alias}" from the server`
          });

          if (typeof e.rootCause !== 'undefined') {
            e.rootCause.data = error.cause,
            e.rootCause.textStatus = error.statusText;
            e.rootCause.errorThrown = error;
            e.rootCause.requestArgs = { token, alias };
          }

          e.severity = atex.aceui.error.severities.MINOR;

          throw e;
        }
      }
    };
  };
})();
